"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = exports.pin = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const PINEAPPLE_URL = 'https://pineapple.fyi';
async function pin(json, url = PINEAPPLE_URL) {
    const init = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            jsonrpc: '2.0',
            method: 'pin',
            params: json,
            id: null
        })
    };
    const res = await (0, cross_fetch_1.default)(url, init);
    return (await res.json()).result;
}
exports.pin = pin;
async function upload(body, url = `${PINEAPPLE_URL}/upload`) {
    const init = { method: 'POST', body };
    const res = await (0, cross_fetch_1.default)(url, init);
    return (await res.json()).result;
}
exports.upload = upload;
